var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-element",attrs:{"data-cy":"heading-elem"}},[_c('h2',{class:_vm.getAlignClassName(_vm.data.data.align),domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }